import { useState, useEffect } from "react";

import { paths } from "../../routes/paths";
import { useAuthContext } from "../../hooks/use-auth-context";
import { SplashScreen } from "../../components/loading-screen";
import { useRouter, useSearchParams } from "../../routes/hooks";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function GuestGuard({ children }: Props) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { loading, authenticated } = useAuthContext();
  const [isChecking, setIsChecking] = useState<boolean>(true);

  // Fix: Use a function for paths.dashboard.root since it now expects a parameter
  const returnTo = searchParams.get("returnTo") || paths.dashboard.root();

  useEffect(() => {
    // Only perform the check when loading is complete
    if (!loading) {
      if (authenticated) {
        // User is authenticated, redirect to dashboard
        router.replace(returnTo);
      } else {
        // User is not authenticated, show the login page
        setIsChecking(false);
      }
    }
  }, [authenticated, loading, router, returnTo]);

  // Show splash screen during the initial loading or during redirect
  if (loading || (isChecking && authenticated)) {
    return <SplashScreen />;
  }

  // Only render children when user is not authenticated
  return <>{children}</>;
}
